import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { clientDetection } from "./app/shared/globalFunctions/globalFunctions";

function setManifest(): void {
    const client = clientDetection();

    const link = document.getElementById(
      'dynamic-manifest'
    ) as HTMLLinkElement;

    if (link) {
      link.href = `/manifests/${client.toLowerCase()}.webmanifest`;
    }
}

setManifest();
bootstrapApplication(AppComponent, appConfig
)
    .catch((err) => console.error(err));
